import { useCapabilities } from '@office-start/capabilities-service';
import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useCallback, useMemo } from 'react';
export var useUpsellTrackingParam = function () {
    var capabilities = useCapabilities().data;
    var context = useOfficeComponentContext().data;
    var lowerCaseRequestOrigin = useMemo(function () {
        var _a;
        return (_a = context === null || context === void 0 ? void 0 : context.requestOrigin.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    }, [context]);
    var checkOrigin = useCallback(function (origin) {
        return lowerCaseRequestOrigin === origin.toLowerCase();
    }, [lowerCaseRequestOrigin]);
    return useMemo(function () {
        if (!capabilities) {
            return '';
        }
        var upsellTrackingParam = '';
        if (capabilities.isPwaInUwp) {
            upsellTrackingParam = 'PWA';
            var pwaOrigins = [
                'WordPad',
                'CovidLockscreen',
                'CovidStartMenu',
                'CovidAMC',
                'CovidActionCenter',
                'HVAStartMenu',
                'CGEAwareness',
            ];
            pwaOrigins.forEach(function (origin) {
                if (checkOrigin(origin)) {
                    upsellTrackingParam += '-' + origin;
                }
            });
        }
        else {
            upsellTrackingParam = 'HomePage';
            var officeHomeOrigins = [
                'RFMGraceToOnline',
                'RFMGraceToOnline2',
                'CovidLockscreen',
                'CovidStartMenu',
                'CovidAMC',
                'CovidActionCenter',
                'RFMSubExpB',
                'RFMSubExpC',
                'EduExp1',
                'EduExp2',
                'HVAStartMenu',
                'MacWXPOO',
                'GetGenuine',
                'FreeOfframpFromDialog',
                'FreeOfframpFromTBA',
                '5DayPassEndedBizbar',
                'GenericRFMBizbar',
            ];
            officeHomeOrigins.forEach(function (origin) {
                if (checkOrigin(origin)) {
                    upsellTrackingParam +=
                        '-' + (origin.startsWith('RFM') ? 'RFM' : origin);
                }
            });
        }
        return upsellTrackingParam;
    }, [capabilities, checkOrigin]);
};
//# sourceMappingURL=useUpsellTrackingParam.js.map